"use client";

import ImageBanner from "../customLayoutServices/ImageBanner";
import { ReactNode } from "react";

type PlaceLayoutProps = {
  imageSrc: string;
  children: ReactNode;
};

export default function PlaceLayout({ imageSrc, children }: PlaceLayoutProps) {
  return (
    <div className="min-h-screen bg-gray-100">
      <ImageBanner src={imageSrc} />
      {children}
    </div>
  );
}
